export const PLAYER_LIST_REQUEST = 'PLAYER_LIST_REQUEST';
export const PLAYER_LIST_SUCCESS = 'PLAYER_LIST_SUCCESS';
export const PLAYER_LIST_FAIL = 'PLAYER_LIST_FAIL';

export const PLAYER_DETAILS_REQUEST = 'PLAYER_DETAILS_REQUEST';
export const PLAYER_DETAILS_SUCCESS = 'PLAYER_DETAILS_SUCCESS';
export const PLAYER_DETAILS_FAIL = 'PLAYER_DETAILS_FAIL';

export const PLAYER_UPDATE_DETAILS_REQUEST = 'PLAYER_UPDATE_DETAILS_REQUEST';
export const PLAYER_UPDATE_DETAILS_SUCCESS = 'PLAYER_UPDATE_DETAILS_SUCCESS';
export const PLAYER_UPDATE_DETAILS_FAIL = 'PLAYER_UPDATE_DETAILS_FAIL';
export const PLAYER_UPDATE_DETAILS_RESET = 'PLAYER_UPDATE_DETAILS_RESET';

export const PLAYER_DELETE_REQUEST = 'PLAYER_DELETE_REQUEST';
export const PLAYER_DELETE_SUCCESS = 'PLAYER_DELETE_SUCCESS';
export const PLAYER_DELETE_FAIL = 'PLAYER_DELETE_FAIL';
export const PLAYER_DELETE_RESET = 'PLAYER_DELETE_RESET';

export const PLAYER_CREATE_REQUEST = 'PLAYER_CREATE_REQUEST';
export const PLAYER_CREATE_SUCCESS = 'PLAYER_CREATE_SUCCESS';
export const PLAYER_CREATE_FAIL = 'PLAYER_CREATE_FAIL';
export const PLAYER_CREATE_RESET = 'PLAYER_CREATE_RESET';

export const PLAYER_LOG_DATES_REQUEST = 'PLAYER_LOG_DATES_REQUEST';
export const PLAYER_LOG_DATES_SUCCESS = 'PLAYER_LOG_DATES_SUCCESS';
export const PLAYER_LOG_DATES_FAIL = 'PLAYER_LOG_DATES_FAIL';

export const PLAYER_LOG_FOR_DATE_REQUEST = 'PLAYER_LOG_FOR_DATE_REQUEST';
export const PLAYER_LOG_FOR_DATE_SUCCESS = 'PLAYER_LOG_FOR_DATE_SUCCESS';
export const PLAYER_LOG_FOR_DATE_FAIL = 'PLAYER_LOG_FOR_DATE_FAIL';

export const PLAYER_RESTART_REQUEST = 'PLAYER_RESTART_REQUEST';
export const PLAYER_RESTART_SUCCESS = 'PLAYER_RESTART_SUCCESS';
export const PLAYER_RESTART_FAIL = 'PLAYER_RESTART_FAIL';

export const PLAYER_ACTIVITY_REQUEST = 'PLAYER_ACTIVITY_REQUEST';
export const PLAYER_ACTIVITY_SUCCESS = 'PLAYER_ACTIVITY_SUCCESS';
export const PLAYER_ACTIVITY_FAIL = 'PLAYER_ACTIVITY_FAIL';
